import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import MultiWrapper from "./MultiWrapper";
import Integer from "./Integer";
import Date from "./Date";

function MultiDate(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);


  return (
    <MultiWrapper fieldSettings={props.fieldSettings} component={Date} />
  )
};

MultiDate.defaultProps = {};

MultiDate.propTypes = {}

export default observer(MultiDate);
